export const usePlatform = () => usePlatformStore().aggregatedPlatformData;
